import React from "react";

export function Worldle() {
  return (
    <span className="font-bold">
      PASSP<span className="text-green-600">O</span>RTLE
    </span>
  );
}
